'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCloudyNightOutline = function IoIosCloudyNightOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.8 17.5c-2.7 0-5 2.2-5 4.8v1l0.1 0.8c-0.4 0-0.9 0-1.1 0-1.5 0.3-2.5 1.4-2.5 2.9 0 0.8 0.2 1.5 0.7 2.1s1.3 0.8 2.1 0.8h12.2c2.1 0 3.9-1.7 3.9-3.8s-1.8-3.9-3.9-3.9c-0.1 0-0.3 0.1-0.4 0.1l-1.1 0.1-0.3-1.1c-0.2-1.1-0.8-2-1.7-2.7s-1.9-1.1-3-1.1z m0-1.2c2.9 0 5.3 2 5.9 4.7h0.6c2.8 0 5.1 2.3 5.1 5.1s-2.3 5.2-5.1 5.2h-12.2c-2.2 0-4.1-1.9-4.1-4.2 0-2.1 1.6-4 3.7-4.1v-0.7c0-3.3 2.7-6.1 6.1-6.1z m18.4 7.6c0.6 0 1.2-0.1 1.8-0.3-0.3 0.5-0.7 1.1-1.1 1.6-1.6 1.8-3.9 3.2-6.6 3.5 0.4-0.5 0.5-1 0.7-1.5 1.5-0.3 2.8-1 3.9-2-1.4 0-2.8-0.4-3.9-1-1.8-0.8-3.3-2.2-4.4-4-1.1-1.6-1.7-3.7-1.7-5.8 0-1.2 0.1-2.4 0.5-3.5-1.9 1-3.3 2.6-4.1 4.6-0.4-0.1-1-0.3-1.4-0.3 1.1-2.9 3.5-5.1 6.4-6.1 0.6-0.1 1.2-0.3 1.9-0.4-0.4 0.5-0.7 1.1-1 1.6-0.6 1.3-0.9 2.7-0.9 4.1 0 2.5 0.9 4.9 2.7 6.7s4.2 2.8 6.7 2.8h0.5z' })
        )
    );
};

exports.default = IoIosCloudyNightOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-cloudy-night-outline.js
// module id = 2360
// module chunks = 0